import { MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/LanguageContext";

const WHATSAPP_NUMBER = "5537998606150";

const copy = {
  pt: {
    title: "Fale diretamente com a Quimical pelo WhatsApp.",
    text: "Envie sua necessidade de cal industrial diretamente para a equipe comercial e técnica. Informe aplicação, cidade, volume e produto, se já souber.",
    cta: "Falar com a Quimical no WhatsApp",
    message: "Olá. Gostaria de falar com a Quimical sobre fornecimento de cal industrial. Posso informar minha aplicação, cidade, volume e especificação.",
  },
  en: {
    title: "Talk directly to Quimical on WhatsApp.",
    text: "Send your industrial lime requirement directly to our commercial and technical team. Share the application, city, volume and product, if known.",
    cta: "Talk to Quimical on WhatsApp",
    message: "Hello. I would like to talk to Quimical about industrial lime supply. I can share my application, city, volume and specification.",
  },
  es: {
    title: "Hable directamente con Quimical por WhatsApp.",
    text: "Envíe su necesidad de cal industrial directamente al equipo comercial y técnico. Informe aplicación, ciudad, volumen y producto, si ya lo conoce.",
    cta: "Hablar con Quimical por WhatsApp",
    message: "Hola. Me gustaría hablar con Quimical sobre suministro de cal industrial. Puedo informar mi aplicación, ciudad, volumen y especificación.",
  },
} as const;

const HomepageWhatsAppContact = () => {
  const { language } = useLanguage();
  const c = copy[language];
  const openWhatsApp = () => {
    window.open(
      `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(c.message)}`,
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <div className="rounded-[2rem] border border-white/10 bg-white/[0.05] p-7 md:p-10">
      <div className="flex h-12 w-12 items-center justify-center rounded-full bg-primary text-white">
        <MessageCircle className="h-6 w-6" />
      </div>
      <h3 className="mt-7 text-2xl font-semibold tracking-[-0.02em] text-white md:text-3xl">{c.title}</h3>
      <p className="mt-4 max-w-xl text-sm leading-7 text-white/60 md:text-base">{c.text}</p>
      <Button size="lg" className="mt-8 h-12 rounded-full px-7 text-base" onClick={openWhatsApp}>
        <MessageCircle className="mr-2 h-5 w-5" />
        {c.cta}
      </Button>
    </div>
  );
};

export default HomepageWhatsAppContact;

